import Vue from 'vue';
import Router from 'vue-router';
import home from './views/home/home.vue';
import root from './views/root.vue';
import i18next from 'i18next';
import store from './store';

const supportedLocales = ['fa', 'en', 'fr', 'ar', 'de'];

Vue.use(Router);

// Lazy load everything but home page!
const contactUs = () => import(/* webpackPrefetch: true */ './views/contact-us/contact-us.vue');
const aboutUs = () => import(/* webpackPrefetch: true */ './views/about-us/about-us.vue');
const manifesto = () => import(/* webpackPrefetch: true */ './views/manifesto/en/manifesto.vue');
const faq = () => import(/* webpackPrefetch: true */ './views/faq/faq.vue');
const getApp = () => import(/* webpackPrefetch: true */ './views/get-app/get-app.vue');
const poc = () => import(/* webpackPrefetch: true */ './views/poc/poc.vue');
const tariff = () => import(/* webpackPrefetch: true */ './views/tariff/tariff.vue');
const rules = () => import(/* webpackPrefetch: true */ './views/rules/rules.vue');
const pocNetworkDescription = () => import(/* webpackPrefetch: true */ './views/poc-network-description/poc-network-description.vue');
const pocVsRadio = () => import(/* webpackPrefetch: true */ './views/poc-vs-radio/poc-vs-radio.vue');
const hospitality = () => import(/* webpackPrefetch: true */ './views/hospitality/hospitality.vue');
const healthcare = () => import(/* webpackPrefetch: true */ './views/healthcare/healthcare.vue');

const locale = require('browser-locale')();
const browserLang = (locale || 'en-US').substring(0, 2);

const getLocalizedTitle = key => {
    return (i18next.t(`common:meta.${key}`) + i18next.t(`common:meta.title`)) || 'آپتین';
};

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '',
            redirect: `/${browserLang}/home`
        },
        {
            path: '/about-us',
            redirect: `/${browserLang}/about-us`
        },
        {
            path: '/home',
            redirect: `/${browserLang}/home`
        },
        {
            path: '/contact-us',
            redirect: `/${browserLang}/contact-us`
        },
        {
            path: '/faq',
            redirect: `/${browserLang}/faq`
        },
        {
            path: '/jobs',
            redirect: `/${browserLang}/jobs`
        },
        {
            path: '/manifesto',
            redirect: `/${browserLang}/manifesto`
        },
        {
            path: '/get-app',
            redirect: `/${browserLang}/get-app`
        },
        {
            path: '/poc',
            redirect: `/${browserLang}/poc`
        },
        {
            path: '/tariff',
            redirect: `/${browserLang}/tariff`
        },
        {
            path: '/rules',
            redirect: `/${browserLang}/rules`
        },
        {
            path: '/poc-network-description',
            redirect: `/${browserLang}/poc-network-description`
        },
        {
            path: '/poc-vs-radio',
            redirect: `/${browserLang}/poc-vs-radio`
        },
        {
            path: '/hospitality',
            redirect: `/${browserLang}/hospitality`
        },
        {
            path: '/healthcare',
            redirect: `/${browserLang}/healthcare`
        },
        {
            path: '/:locale',
            component: root,
            children: [
                {
                    path: '',
                    name: '',
                    component: home
                },
                {
                    path: 'home',
                    name: 'home',
                    component: home
                },
                {
                    path: 'about-us',
                    name: 'about-us',
                    component: aboutUs
                },
                {
                    path: 'contact-us',
                    name: 'contact-us',
                    component: contactUs
                },
                {
                    path: 'faq',
                    name: 'faq',
                    component: faq
                },
                {
                    path: 'get-app',
                    name: 'get-app',
                    component: getApp
                },
                {
                    path: 'manifesto',
                    name: 'manifesto',
                    component: manifesto
                },
                {
                    path: 'poc',
                    name: 'poc',
                    component: poc
                },
                {
                    path: 'tariff',
                    name: 'tariff',
                    component: tariff
                },
                {
                    path: 'rules',
                    name: 'rules',
                    component: rules
                },
                {
                    path: 'poc-network-description',
                    name: 'poc-network-description',
                    component: pocNetworkDescription
                },
                {
                    path: 'poc-vs-radio',
                    name: 'poc-vs-radio',
                    component: pocVsRadio
                },
                {
                    path: 'hospitality',
                    name: 'hospitality',
                    component: hospitality
                },
                {
                    path: 'healthcare',
                    name: 'healthcare',
                    component: healthcare
                },
                {
                    path: '404',
                    name: '404',
                    meta: {
                        is404NotFound: true
                    }
                },
                {
                    path: '/:pathMatch(.*)*',
                    redirect: `/${browserLang}/404`,
                }
            ]
        },
    ],
    scrollBehavior() {
        return {
            x: 0,
            y: 0
        }
    }
});
router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.is404NotFound)) {
        store.commit('setNotFoundStatus', true);
    } else {
        store.commit('setNotFoundStatus', false);
    }
    let locale = to.params.locale;
    if (!locale && to.name === 'manifesto') {
        locale = to.path.split('/')[1];
    } else if (!locale) {
        locale = browserLang;
    }

    if (locale === 'fa' || locale === 'ar') {
        document.querySelector('body').classList.add('is-rtl')
        // document.querySelector('body').classList.toggle('rtl');
    } else {
        document.querySelector('body').classList.add('is-ltr')
        // document.querySelector('body').classList.toggle('ltr');
    }

    // if (locale === 'fa' || locale === 'ar') {
    //   document.querySelector('body').classList.toggle('rtl');
    // }

    // ugly workaround for waiting until the translations are ready
    // to set the title
    const interval = setInterval(() => {
        if (store.getters.isI18nLoaded) {
            document.title = getLocalizedTitle(to.name);
            clearInterval(interval);
        }
    }, 500);

    if (supportedLocales.indexOf(locale) === -1) {
        next(`/${browserLang}/404`);
    } else {
        i18next.changeLanguage(locale);
        return next();
    }


});

function getRoutesList(routes, pre) {
    return routes.reduce((array, route) => {
        const path = `${pre}${route.path}`;

        if (route.path !== '*') {
            array.push(path);
        }

        if (route.children) {
            array.push(...getRoutesList(route.children, `${path}/`));
        }

        return array;
    }, []);
}

function getRoutesXML() {
    const list = getRoutesList(router.options.routes, 'https://www.uptin.app')
        .map(route => `<url><loc>${route}</loc></url>`)
        .join('\r\n');
    return `<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.sitemaps.org/schemas/sitemap/0.9 http://www.sitemaps.org/schemas/sitemap/0.9/sitemap.xsd">
    ${list}
  </urlset>`;
}

getRoutesXML();

console.log(getRoutesXML());
export default router;
